import BusinessCard from './BusinessCard';
import Icon from '../../../components/AppIcon';

const BusinessGrid = ({ businesses, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent mb-4"></div>
          <p className="text-muted-foreground">Cargando negocios...</p>
        </div>
      </div>
    );
  }

  if (businesses?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="bg-muted rounded-full p-6 mb-4">
          <Icon name="Search" size={48} color="var(--color-muted-foreground)" />
        </div>
        <h3 className="text-xl font-bold text-foreground mb-2">
          No se encontraron negocios
        </h3>
        <p className="text-muted-foreground max-w-md">
          Intenta ajustar tus filtros de búsqueda o explora otras categorías para descubrir más negocios con descuentos exclusivos.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {businesses?.map((business) => (
        <BusinessCard key={business?.id} business={business} />
      ))}
    </div>
  );
};

export default BusinessGrid;